<app-modal
	#newStudyForm
	[size]="'lg'"
	[hasCloseButton]="false"
	[hasConfirmButton]="false"
	[title]="(editMode ? 'studies.edit_study' : 'studies.create_new_study') | translate"
>
	<!-- Success Message -->
	<div *ngIf="successMessage" class="text-center py-4">
		<div class="success-icon mb-3">
			<fa-icon icon="check-circle" size="3x" class="text-success"></fa-icon>
		</div>
		<h4 class="text-success">{{successMessage}}</h4>
		<div class="mt-4">
			<button class="btn btn-primary" (click)="closeSuccess()">{{'g.close' | translate}}</button>
		</div>
	</div>

	<!-- Wizard Content -->
	<div *ngIf="!successMessage">
		<alert *ngIf="formError != null" [type]="'danger'">
			<div [innerHTML]="formError"></div>
		</alert>

		<!-- Step Indicator -->
		<div class="wizard-steps mb-4" *ngIf="!editMode">
			<div
				class="step-indicator"
				[class.active]="currentStep === 1"
				[class.completed]="currentStep > 1"
				(click)="currentStep > 1 ? goToStep(1) : null"
			>
				<span class="step-number">1</span>
				<span class="step-label">{{'studies.device_setup' | translate}}</span>
			</div>
			<div class="step-connector" [class.completed]="currentStep > 1"></div>
			<div
				class="step-indicator"
				[class.active]="currentStep === 2"
				[class.completed]="currentStep > 2"
				(click)="currentStep > 2 ? goToStep(2) : null"
			>
				<span class="step-number">2</span>
				<span class="step-label">{{'studies.study_details' | translate}}</span>
			</div>
			<div class="step-connector" [class.completed]="currentStep > 2" *ngIf="isNewCustomer"></div>
			<div
				class="step-indicator"
				[class.active]="currentStep === 3"
				[class.completed]="currentStep > 3"
				*ngIf="isNewCustomer"
				(click)="currentStep > 3 ? goToStep(3) : null"
			>
				<span class="step-number">3</span>
				<span class="step-label">{{'studies.create_new_customer' | translate}}</span>
			</div>
			<div class="step-connector" [class.completed]="currentStep > 3" *ngIf="isNewSite"></div>
			<div
				class="step-indicator"
				[class.active]="currentStep === 4"
				[class.completed]="currentStep > 4"
				*ngIf="isNewSite"
				(click)="currentStep > 4 ? goToStep(4) : null"
			>
				<span class="step-number">{{ isNewCustomer ? '4' : '3' }}</span>
				<span class="step-label">{{'studies.create_new_site' | translate}}</span>
			</div>
			<div class="step-connector" [class.completed]="currentStep > 4" *ngIf="showShareWithCustomerStep"></div>
			<div
				class="step-indicator"
				[class.active]="currentStep === 5"
				[class.completed]="currentStep > 5"
				*ngIf="showShareWithCustomerStep"
			>
				<span class="step-number">{{ isNewCustomer ? '5' : (isNewSite ? '4' : '3') }}</span>
				<span class="step-label">{{'studies.share_study_details' | translate}}</span>
			</div>
		</div>

		<!-- ============ STEP 1: Device Setup ============ -->
		<div *ngIf="currentStep === 1">
			<h5 class="mb-3">{{'studies.wizard_step_1_title' | translate}}</h5>
			<p><b>{{'note.note' | translate}}</b>{{'studies.new_study_form_note' | translate}}</p>
			<form #deviceSetupValidate="validate-form" validate-form="study" [disableNotification]="true">
				<!-- Truck Information -->
				<fieldset class="mb-3">
					<legend><b>{{'studies.truck_information' | translate}}</b></legend>

					<div class="form-group row">
						<label class="col-sm-4 col-form-label">{{'devices.truck_id' | translate}} *</label>
						<div class="col-sm-8">
							<input
								type="text"
								class="form-control"
								name="truck_id"
								[(ngModel)]="deviceSetupData.truckId"
								required
							/>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-4 col-form-label">{{'devices.truck_sn' | translate}} *</label>
						<div class="col-sm-8">
							<input
								type="text"
								class="form-control"
								name="truck_sn"
								[(ngModel)]="deviceSetupData.truckSn"
								required
							/>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-4 col-form-label">{{'devices.truck_manufacturer' | translate}} *</label>
						<div class="col-sm-8">
							<input
								type="text"
								class="form-control"
								name="truck_manufacturer"
								[(ngModel)]="deviceSetupData.truckManufacturer"
								required
							/>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-4 col-form-label"
							>{{'devices.truck_manufacturing_year' | translate}} *</label
						>
						<div class="col-sm-8">
							<input
								type="number"
								class="form-control"
								name="truck_manufacturing_year"
								[(ngModel)]="deviceSetupData.truckManufacturingYear"
								required
								[ngClass]="isTruckManufacturingYearValid ? '' : 'invalid-input'"
							/>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-4 col-form-label">{{'devices.truck_type' | translate}} *</label>
						<div class="col-sm-8">
							<input
								type="text"
								class="form-control"
								name="truck_type"
								[(ngModel)]="deviceSetupData.truckType"
								required
							/>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-4 col-form-label">{{'studies.number_of_cables' | translate}} *</label>
						<div class="col-sm-8">
							<ng-select
								[items]="deviceCommonService.ddLists.current_cable_scale"
								bindLabel="label"
								bindValue="id"
								[clearable]="false"
								name="number_of_cables"
								[(ngModel)]="deviceSetupData.numberOfCables"
								required
							></ng-select>
						</div>
					</div>
				</fieldset>

				<!-- Battery Information -->
				<fieldset class="mb-3">
					<legend><b>{{'studies.battery_information' | translate}}</b></legend>

					<div class="form-group row">
						<label class="col-sm-4 col-form-label">{{'devices.battery_capacity' | translate}} *</label>
						<div class="col-sm-8">
							<input
								type="number"
								class="form-control"
								name="battery_capacity"
								[(ngModel)]="deviceSetupData.batteryCapacity"
								required
							/>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-4 col-form-label">{{'devices.battery_type' | translate}} *</label>
						<div class="col-sm-8">
							<ng-select
								[items]="batteryTypeOptions"
								bindLabel="label"
								bindValue="id"
								[clearable]="false"
								name="battery_type"
								[(ngModel)]="deviceSetupData.batteryType"
								required
							></ng-select>
						</div>
					</div>

					<div class="form-group row">
						<label class="col-sm-4 col-form-label"
							>{{'studies.nominal_battery_voltage' | translate}} *</label
						>
						<div class="col-sm-8">
							<ng-select
								[items]="batteryVoltageOptions"
								[clearable]="false"
								name="nominal_battery_voltage"
								[(ngModel)]="deviceSetupData.nominalBatteryVoltage"
								placeholder="{{'studies.select_battery_voltage' | translate}}"
								required
							></ng-select>
						</div>
					</div>
				</fieldset>
			</form>
		</div>

		<!-- ============ STEP 2: Study Details ============ -->
		<div *ngIf="currentStep === 2">
			<h5 class="mb-3">{{'studies.wizard_step_2_title' | translate}}</h5>
			<form #studyDetailsValidate="validate-form" validate-form="study" [disableNotification]="true">
				<div class="form-group row">
					<label for="studyName" class="col-sm-4 col-form-label">{{'studies.name' | translate}} *</label>
					<div class="col-sm-8">
						<input
							type="text"
							class="form-control"
							[ngClass]="{'is-invalid': hasApiFieldError('name')}"
							name="name"
							id="studyName"
							[(ngModel)]="studyDetailsData.studyName"
							required
						/>
						<div *ngIf="hasApiFieldError('name')" class="invalid-feedback d-block">
							{{getApiFieldError('name')}}
						</div>
					</div>
				</div>

				<div class="form-group row" *ngIf="!['customer', 'site'].includes(parent)">
					<div class="col-sm-4"></div>
					<div class="col-sm-8">
						<div class="form-check custom-checkbox">
							<input
								type="checkbox"
								class="form-check-input"
								id="isNewCustomer"
								name="isNewCustomer"
								[(ngModel)]="isNewCustomer"
								(ngModelChange)="onNewCustomerChange()"
							/>
							<label class="form-check-label font-weight-bold" for="isNewCustomer"
								>{{'studies.create_new_customer' | translate}}</label
							>
						</div>
					</div>
				</div>

				<div class="form-group row" *ngIf="!isNewCustomer">
					<label for="customerId" class="col-sm-4 col-form-label"
						>{{'studies.customer_name' | translate}} *</label
					>
					<div class="col-sm-8">
						<ng-select
							[items]="customers"
							bindLabel="customer_name"
							bindValue="id"
							placeholder="{{'customer.select_customer' | translate}}"
							name="customer_id"
							[(ngModel)]="studyDetailsData.customerId"
							[clearable]="false"
							(ngModelChange)="onCustomerChange($event)"
							required
							[disabled]="['customer', 'site'].includes(parent)"
						></ng-select>
					</div>
				</div>
				<div class="form-group row" *ngIf="!['site'].includes(parent)">
					<div class="col-sm-4"></div>
					<div class="col-sm-8">
						<div class="form-check custom-checkbox">
							<input
								type="checkbox"
								class="form-check-input"
								id="isNewSite"
								name="isNewSite"
								[(ngModel)]="isNewSite"
								(ngModelChange)="onNewSiteChange()"
								[disabled]="isNewCustomer"
							/>
							<label class="form-check-label font-weight-bold" for="isNewSite"
								>{{'studies.create_new_site' | translate}}</label
							>
						</div>
					</div>
				</div>

				<div class="form-group row" *ngIf="!isNewSite">
					<label for="siteId" class="col-sm-4 col-form-label">{{'studies.site_name' | translate}} *</label>
					<div class="col-sm-8">
						<ng-select
							[items]="sites"
							bindLabel="name"
							bindValue="id"
							placeholder="{{'site.select_site' | translate}}"
							name="site_id"
							[(ngModel)]="studyDetailsData.siteId"
							[clearable]="false"
							required
							[disabled]="['site'].includes(parent)"
						></ng-select>
					</div>
				</div>

				<div class="form-group row">
					<label for="serialNumber" class="col-sm-4 col-form-label"
						>{{'studies.iotah_ps_sn' | translate}} *</label
					>
					<div class="col-sm-8">
						<ng-select
							[items]="devices"
							bindLabel="label"
							bindValue="mac_address"
							name="mac_address"
							[(ngModel)]="studyDetailsData.serialNumber"
							[clearable]="false"
							required
							[ngClass]="{'border border-danger is-invalid': hasApiFieldError('mac_address')}"
							[disabled]="['study', 'device'].includes(parent)"
						></ng-select>
						<div *ngIf="hasApiFieldError('mac_address')" class="invalid-feedback d-block">
							{{getApiFieldError('mac_address')}}
						</div>
					</div>
				</div>
			</form>
		</div>

		<!-- ============ STEP 3: Create New Customer ============ -->
		<div *ngIf="currentStep === 3">
			<h5 class="mb-3">{{'studies.wizard_step_3_title' | translate:{step: 3} }}</h5>
			<form
				#newCustomerValidate="validate-form"
				validate-form="editCustomer"
				[innerModelGroups]="['customerInputs']"
				[disableNotification]="true"
			>
				<div class="card">
					<app-customer-edit
						[customer]="newCustomer"
						[enterpriseList]="enterprisesList"
						[hideEnterprise]="!currentUser.isSCT"
					></app-customer-edit>
				</div>
				<div *ngIf="hasApiFieldError('customer_name')" class="invalid-feedback d-block mt-2">
					{{getApiFieldError('customer_name')}}
				</div>
			</form>
		</div>

		<!-- ============ STEP 4: Create New Site ============ -->
		<div *ngIf="currentStep === 4">
			<h5 class="mb-3">{{'studies.wizard_step_4_title' | translate:{step: isNewCustomer ? 4 : 3} }}</h5>
			<form #newSiteValidate="validate-form" validate-form="editSite" [innerModelGroups]="['site']" [disableNotification]="true">
				<div class="card">
					<app-site-edit
						[site]="newSite"
						[enterpriseList]="enterprisesList"
						[customerEnterprises]="customerEnterprises"
						[miniForm]="true"
						[hideEnterprise]="!currentUser.isSCT"
						[hideSettings]="true"
						[hideAddressFields]="true"
					></app-site-edit>
				</div>
				<div class="row mt-3">
					<div class="col-12 mb-3">
						<app-mapbox-search
							class="border-radius main-blue-border"
							[latitude]="newSiteMap.latitude"
							[longitude]="newSiteMap.longitude"
							[zoom]="[3]"
							[zoomIn]="true"
							[showPopup]="false"
							[dots]="[newSiteMap]"
							[clickEnabled]="true"
							(onAddressChanged)="updateSiteCoords($event)"
						>
						</app-mapbox-search>
					</div>
				</div>
				<div *ngIf="hasApiFieldError('name')" class="invalid-feedback d-block mt-2">
					{{getApiFieldError('name')}}
				</div>
			</form>
		</div>

		<!-- ============ STEP 5: Share Study Details ============ -->
		<div *ngIf="showShareWithCustomerStep && currentStep === 5">
			<h5 class="mb-3">
				{{'studies.wizard_step_5_title' | translate:{step: isNewCustomer ? 5 : (isNewSite ? 4 : 3)} }}
			</h5>
			<div class="text-center py-4">
				<p class="h6">{{'studies.share_study_question' | translate}}</p>
				<div class="mt-4">
					<button class="btn btn-primary mr-3" (click)="setShareAndSubmit(true)">
						{{'g.yes' | translate}}
					</button>
					<button class="btn btn-light" (click)="setShareAndSubmit(false)">{{'g.no' | translate}}</button>
				</div>
			</div>
		</div>

		<!-- ============ Navigation Buttons ============ -->
		<div class="form-group row mt-4" *ngIf="editMode">
			<div class="col-sm-12 d-flex justify-content-between">
				<button class="btn btn-light" (click)="cancelWizard()">{{'g.cancel' | translate}}</button>
				<button class="btn btn-primary" (click)="submitEdit()">{{'g.save' | translate}}</button>
			</div>
		</div>

		<div class="form-group row mt-4" *ngIf="!editMode && currentStep !== 5">
			<div class="col-sm-12 d-flex justify-content-between">
				<div>
					<button class="btn btn-light" (click)="cancelWizard()">{{'g.cancel' | translate}}</button>
				</div>
				<div>
					<!-- Back button -->
					<button *ngIf="currentStep > 1" class="btn btn-secondary mr-2" (click)="prevStep()">
						{{'g.back' | translate}}
					</button>

					<!-- Next button -->
					<button class="btn btn-primary" (click)="nextStep()">
						{{(isFinalCreateStep ? 'g.submit' : 'g.next') | translate}}
					</button>
				</div>
			</div>
		</div>
	</div>
</app-modal>
